<template>
  <div class="bg-white rounded-lg shadow">
    <div class="bg-white rounded-lg shadow overflow-hidden">
      <div class="hidden sm:block">
        <div class="border-b border-gray-200">
          <nav class="-mb-px flex space-x-8" aria-label="Tabs">
            <slot name="items" />
          </nav>
        </div>
      </div>
      <section class="divide-y divide-gray-200 lg:col-span-9">
        <slot name="main" />
      </section>
    </div>
  </div>
</template>

